export type Country = { code: string; label: string };

export const DEFAULT_NATIONALITY = 'BR';

export const COUNTRIES: Country[] = [
  { code: 'BR', label: 'Brasil' },
  { code: 'AR', label: 'Argentina' },
  { code: 'CL', label: 'Chile' },
  { code: 'CO', label: 'Colômbia' },
  { code: 'DE', label: 'Alemanha' },
  { code: 'ES', label: 'Espanha' },
  { code: 'FR', label: 'França' },
  { code: 'GB', label: 'Reino Unido' },
  { code: 'IT', label: 'Itália' },
  { code: 'MX', label: 'México' },
  { code: 'PT', label: 'Portugal' },
  { code: 'US', label: 'Estados Unidos' },
  { code: 'UY', label: 'Uruguai' },
  { code: 'XX', label: 'Outro país' },
];
